import { ReactElement, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../store/store';
import flat from 'flat';

type RedirectProps = {
    to: string;
};

const Redirect = ({ to }: RedirectProps): ReactElement => {
    const navigate = useNavigate();
    const { search } = useLocation();

    const config = useSelector((state: RootState) => state.common.config);

    useEffect(() => {
        // dispatch(actions.startLoading());
        if (!!config) {
            const index = Object.values(flat(config.callFromComponentToTO)).findIndex(e =>
                (e as string).includes('?')
                    ? (e as string).split('?')[0] === window.location.pathname
                    : e === window.location.pathname
            );
            if (index === -1) {
                navigate(to + search);
            }
        } else {
            navigate(to + search);
        }
    }, []);

    return <></>;
};

export default Redirect;
